import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  step: null,
}

export const STEPS = {
  shareOrReschedule: 'shareOrReschedule',
  hostPicker: 'hostPicker'
}

const slice = createSlice({
  name: 'hostReschedule',
  initialState,
  reducers: {
    closePopup: (state) => {
      Object.assign(state, initialState)
    },
    goBack: (state) => {
      state.step = STEPS.shareOrReschedule
    },
    openShareOrReschedulePopup: (state) => {
      state.step = STEPS.shareOrReschedule
    },
    openHostPickerPopup: (state) => {
      state.step = STEPS.hostPicker
    }
  }
})

export const {
  reducer,
  actions: {
    closePopup,
    goBack,
    openShareOrReschedulePopup,
    openHostPickerPopup,
  }
} = slice
